(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/header.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/header.js');
"use strict";

var _svs$lyckoplatsen$dat;

const {
  Image
} = svs.content.image_v2;
const {
  useRef
} = React;
const {
  useHistory
} = ReactRouterDOM;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const {
  trackClickPlayLyckoplatsen
} = svs.lyckoplatsen.page_start;
const {
  heroImage,
  heroGuideLinkColor
} = svs.lyckoplatsen.data.hero;
const {
  MapStart,
  HeaderText
} = svs.lyckoplatsen.components.page_start.react.components;
const totalWinAmountSek = ((_svs$lyckoplatsen$dat = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat === void 0 || (_svs$lyckoplatsen$dat = _svs$lyckoplatsen$dat.startPage) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.totalWinAmountSek) || 0;
const formatCurrency = svs.utils.format.Currency;
const Header = () => {
  const history = useHistory();
  const headerRef = useRef(null);
  const handlePlayClick = () => {
    trackClickPlayLyckoplatsen(true);
    history.push('/spela');
  };
  const showMap = svs.core.detect.feature('ft-lyckoplatsen-startpage-map');
  const theImage = svs.lyckoplatsen.hooks.useOrientationDetect() === 'landscape' ? heroImage.LANDSCAPE : heroImage.PORTRAIT;
  const handleScrollTo = () => {
    if (headerRef.current) {
      const headerHeight = document.querySelector('header').offsetHeight;
      const targetPos = headerRef.current.getBoundingClientRect().bottom + window.scrollY - headerHeight;
      window.scrollTo({
        top: targetPos,
        behavior: 'smooth'
      });
    }
  };
  return React.createElement("div", {
    className: "lp-page-start-header",
    ref: headerRef
  }, React.createElement("div", {
    className: "lp-page-start-header-content f-content"
  }, !showMap && React.createElement(HeaderText, null), showMap && React.createElement("div", {
    className: "header-result-text-top gsap-result-text-top f-content"
  }, React.createElement("h4", null, "Vinster senaste fyra veckorna"), React.createElement("h1", null, formatCurrency(totalWinAmountSek), " kr")), React.createElement(Button, {
    className: "lp-green header-choose-btn gsap-choose-btn",
    onClick: handlePlayClick,
    size: 300
  }, "V\xE4lj din lyckoplats"), React.createElement("div", {
    className: "lp-guide-button gsap-guide-button",
    type: "button",
    onClick: handleScrollTo
  }, React.createElement("p", {
    style: heroGuideLinkColor === 'fc-white' ? {
      color: 'white'
    } : undefined
  }, "S\xE5 funkar Lyckoplatsen"), React.createElement(Icon, {
    size: "600",
    color: heroGuideLinkColor,
    icon: "menu-down"
  }))), showMap && React.createElement(MapStart, null), !showMap && React.createElement(Image, {
    cssSelectors: "lp-hero-multi-image background-image-wrapper image-wrapper-fit",
    image: theImage
  }));
};
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  Header
});

 })(window);